import React from 'react'

class MainBanner extends React.Component {
    render() {
        return (
            <div id="home" className="main-banner item-bg-one">
                <div id="particles-js"></div>
                <div className="d-table">
                    <div className="d-table-cell">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 col-md-12">
                                    <div className="main-banner-text">
                                        <h1><span className='main beige-color'>S</span>TNL</h1>
                                        <h2> MEDIA <span className='beige-color'>INVEST</span><br /> HOLDING</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default MainBanner